import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
export const LocalSDKContext = createContext({
    onConnectCallback: undefined,
    onLogoutCallback: undefined,
    disableBSMNTAuthentication: false,
});
/**
 * Local SDK Provider that wraps the app and provides internal SDK state
 */
export function LocalSDKProvider({ children, onConnectCallback, onLogoutCallback, disableBSMNTAuthentication, }) {
    return (_jsx(LocalSDKContext.Provider, { value: {
            onConnectCallback,
            onLogoutCallback,
            disableBSMNTAuthentication,
        }, children: children }));
}
